import React from "react";
import close from "../../../assets/close.svg";
import "./CloseBtn.scss";
type CloseBtnprop = {
  className?: string;
  onClose: () => void;
  style?: {}
};

const CloseBtn: React.FC<CloseBtnprop> = ({ className, onClose, style }) => {
  return (
    <button className={`close-btn ${className}`} onClick={onClose} style={style}>
      <img src={close} alt="close-icon" />
    </button>
  );
};

export default CloseBtn;
